<ag-login *ngIf="canRender" [isGipLogin]="isGipLogin" [gip]="gip" [dataid]="dataid"></ag-login>
